var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniLeisure04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.621094,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#5BA89F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_15766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.621094,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_15766)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.902,
    y: 109.432,
    width: 6.15246,
    height: 118.817,
    transform: "rotate(32.1381 190.902 109.432)",
    fill: "#F0D5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.403 30.3583C211.341 25.6817 217.514 24.2723 222.19 27.2102L256.609 48.833C261.286 51.771 262.695 57.9437 259.757 62.6203L233.571 104.303C230.124 109.79 224.233 113.267 217.763 113.632L190.948 115.147L180.673 90.3312C178.195 84.3444 178.77 77.5278 182.217 72.0411L208.403 30.3583Z",
    fill: "#EB6A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.431 69.2654C215.524 69.1167 215.655 68.9952 215.811 68.9132L221.309 66.0073C221.65 65.8275 222.057 66.0833 222.043 66.4679L221.811 72.6831C221.805 72.8586 221.752 73.0292 221.659 73.1779L189.509 124.354C189.216 124.822 188.598 124.963 188.131 124.669L183.596 121.82C183.129 121.527 182.988 120.909 183.281 120.442L215.431 69.2654Z",
    fill: "#341D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.583 216.554L137.885 206.521C138.179 206.053 138.038 205.436 137.571 205.142L133.036 202.294C132.569 202 131.951 202.141 131.658 202.609L125.355 212.642L131.583 216.554Z",
    fill: "#341D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.953 218.75L138.882 215.677C139.176 215.209 139.035 214.592 138.567 214.299L124.355 205.37C123.887 205.076 123.27 205.217 122.976 205.685L121.047 208.758C120.753 209.226 120.894 209.843 121.362 210.136L135.574 219.065C136.042 219.359 136.659 219.218 136.953 218.75Z",
    fill: "#341D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.356 184.35L150.529 184.353L157.023 175.399L159.17 172.073C155.538 174.823 149.338 179.982 145.356 184.35Z",
    fill: "#C2BDE3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.332,
    y: 123.961,
    width: 5.07072,
    height: 97.9261,
    transform: "rotate(48.2092 213.332 123.961)",
    fill: "#F0D5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.59 63.8827C245.04 59.9054 251.961 60.6862 255.412 65.5551L270.286 86.5355C273.008 90.3746 272.685 95.5919 269.51 99.0655L248.085 122.507C242.85 128.234 234.775 130.416 227.368 128.107L212.62 123.508L208.741 106.067C207.17 99.0006 209.539 91.6369 214.936 86.8129L240.59 63.8827Z",
    fill: "#341D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.919 66.4981C248.037 62.8176 254.359 63.1721 258.039 67.2898L278.021 89.6455C281.701 93.7632 281.347 100.085 277.229 103.765L249.645 128.42C244.814 132.738 238.191 134.448 231.873 133.009L212.061 128.494L209.789 108.301C209.064 101.862 211.504 95.4711 216.335 91.153L243.919 66.4981Z",
    fill: "#EB6A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.881 97.7737C242.012 97.6567 242.172 97.5762 242.344 97.5403L247.166 96.5342C247.543 96.4556 247.864 96.8143 247.744 97.1799L246.205 101.86C246.15 102.027 246.052 102.176 245.921 102.293L208.95 135.34C208.538 135.708 207.906 135.672 207.538 135.26L204.831 132.232C204.463 131.82 204.498 131.188 204.91 130.82L241.881 97.7737Z",
    fill: "#341D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.908 195.266L149.058 188.875C149.47 188.507 149.505 187.875 149.137 187.463L146.43 184.435C146.062 184.023 145.43 183.988 145.018 184.356L137.869 190.747L141.908 195.266Z",
    fill: "#341D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 198.109L147.759 196.35C148.171 195.982 148.206 195.35 147.838 194.938L138.854 184.886C138.486 184.475 137.854 184.439 137.442 184.807L135.475 186.566C135.063 186.935 135.028 187.567 135.396 187.978L144.38 198.03C144.749 198.442 145.381 198.477 145.793 198.109Z",
    fill: "#341D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.289 242.311V222.514H190.055C194.553 222.514 197.137 225.289 197.137 229.186C197.137 233.137 194.512 235.857 189.945 235.857H186.391V242.311H182.289ZM186.391 232.549H189.289C191.723 232.549 192.912 231.182 192.898 229.186C192.912 227.217 191.723 225.891 189.289 225.877H186.391V232.549ZM201.102 242.557C199.816 242.557 198.777 241.531 198.805 240.26C198.777 239.002 199.816 237.977 201.102 237.99C202.318 237.977 203.371 239.002 203.371 240.26C203.371 241.531 202.318 242.557 201.102 242.557ZM206.707 242.311V222.514H214.473C218.971 222.514 221.555 225.289 221.555 229.186C221.555 233.137 218.93 235.857 214.363 235.857H210.809V242.311H206.707ZM210.809 232.549H213.707C216.141 232.549 217.33 231.182 217.316 229.186C217.33 227.217 216.141 225.891 213.707 225.877H210.809V232.549ZM228.117 222.514V242.311H224.07V222.514H228.117ZM237.988 242.611C233.436 242.598 230.646 239.658 230.66 234.955C230.646 230.375 233.477 227.271 237.824 227.271C241.721 227.271 244.797 229.732 244.797 234.791V235.939H234.652C234.652 238.182 235.979 239.562 238.07 239.576C239.451 239.562 240.436 238.961 240.832 238.072H244.688C244.113 240.82 241.652 242.598 237.988 242.611ZM234.652 233.396H240.969C240.955 231.592 239.711 230.293 237.906 230.307C236.047 230.293 234.734 231.688 234.652 233.396Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLeisure04);
export default __webpack_public_path__ + "static/media/mini_leisure_04.e8f81a39607902578c25faeb318e898a.svg";
export { ForwardRef as ReactComponent };